import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SkillPage from "./pages/SkillPage";
import { skills } from "./data";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/home";
import "./styles/custom.css";
import ScrollToTop from "./components/ScrollToTop";
import Contact from "./pages/contact";
import Resume from "./pages/resume";
import Projects from "./pages/projects";
import About from "./pages/about";
import Error404 from "./components/Error404";
import CookieBanner from './components/CookieBanner';

function App() {
    const { languages, tools, api, lang } = skills;
    console.log(languages.concat(tools, api));
    return (
        <Router>
            <>
                <NavBar />
                <div
                    className="space"
                    style={{ height: "10vh" }}
                ></div>
                <CookieBanner />
                <ScrollToTop />
            </>
            <Routes>
                <Route
                    path="/"
                    element={<Home />}
                />
                <Route
                    path="/contact"
                    element={<Contact/>}
                />
                <Route
                    path="/about"
                    element={<About/>}
                />
                <Route
                    path="/projects"
                    element={<Projects/>}
                />
                <Route
                    path="/resume"
                    element={<Resume/>}
                />
                {languages.concat(tools, api, lang).map((skill, index) => (
                    <Route
                        key={index}
                        path={`/skill/${skill.link}`}
                        element={<SkillPage skill={skill} />}
                    />
                ))}
                <Route
                    path="*"
                    element={<Error404/>}
                />
            </Routes>
            <Footer/>
        </Router>
    );
}

export default App;
